import ProductListingLevels from '@deltek/specification-client/core/Constants/productListingLevels'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { alpha, makeStyles } from '@material-ui/core/styles'
import { processEnv } from 'components/configuration/environmentVariables'
import React from 'react'

const useStyles = makeStyles(() => ({
    menuItem: {
        fontSize: pxToRem(16),
        '&:hover': {
            backgroundColor: alpha('#29e3bf', 0.2),
            cursor: 'pointer',
        },
    },
}))

export interface ListingLevelVariantProps {
    onChange?: (value: string) => void
}

const ListingLevelVariant: React.FC<ListingLevelVariantProps> = ({
    onChange,
}) => {
    const classes = useStyles()

    const handleChange = (value: string) => () => {
        onChange?.(value)
    }

    return (
        <List data-testid={'optionList'}>
            {Object.values(
                processEnv.REACT_APP_EnableBadgelessCards === '1'
                    ? ProductListingLevels.filter(
                          (item) =>
                              !['Premium MasterSpec', 'Premium', 'Premium Proprietary'].includes(item)
                      )
                    : ProductListingLevels.filter(
                          (item) => item !== 'Product Listing'
                      )
            ).map((value) => (
                <ListItem
                    className={classes.menuItem}
                    onClick={handleChange(value)}
                    data-testid={value}
                    key={value}
                >
                    {value}
                </ListItem>
            ))}
        </List>
    )
}

export default ListingLevelVariant
